/** 本会话是否已自动展示过连账户引导页（SC-03）；PRD：「本会话仅自动出现一次」。 */
export const ETF_OVERLAP_PROMPT_SHOWN_KEY = "etf_overlap_prompt_shown";
/** 引导页进场动效是否已播放过（Figma 标注：仅首次进入播放，返回不重播）。 */
export const ETF_OVERLAP_PROMPT_ANIM_KEY = "etf_overlap_prompt_anim";
